import React from 'react';
import { Link } from 'react-router-dom';
import { Link2, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { useHowItWorksTopics } from '../../lib/howItWorksHierarchy';
import { useRelatedTopics } from '../../lib/relatedTopics';

// "You might also want to read" row shown below a How Does It Work? topic's content --
// category/subcategory match first, then keyword overlap, then popularity, then recency
// (see lib/relatedTopics.js for the full ranking rationale). Renders nothing while the
// catalog is loading or fewer than 1 related topic is found.
const RelatedTopics = ({ topicId }) => {
  const { topics } = useHowItWorksTopics();
  const related = useRelatedTopics(topicId, topics, 3);

  if (related.length === 0) return null;

  return (
    <section className="border-t border-structure bg-aluminum" data-testid="related-topics-section">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-center gap-2 mb-6">
          <Link2 className="h-5 w-5 text-autoxium-blue" />
          <h2 className="font-chivo text-2xl font-bold uppercase tracking-tight">Related Topics</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {related.map((topic) => (
            <Link
              key={topic.topic_id}
              to={`/how-it-works/${topic.topic_id}`}
              data-testid={`related-topic-card-${topic.topic_id}`}
            >
              <Card className="technical-card h-full border-autoxium-blue/30">
                <CardContent className="p-6 flex flex-col h-full">
                  {(topic.subcategory || topic.category) && (
                    <Badge variant="outline" className="w-fit font-mono text-xs uppercase tracking-wider mb-4">
                      {topic.subcategory || topic.category}
                    </Badge>
                  )}
                  <h3 className="font-chivo text-lg font-bold mb-2 line-clamp-2">{topic.title}</h3>
                  <p className="text-muted-foreground text-sm mb-4 line-clamp-3 flex-1">{topic.short_description}</p>
                  <div className="flex items-center justify-end pt-4 border-t border-structure">
                    <ChevronRight className="h-4 w-4 text-autoxium-blue" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedTopics;
